import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";

interface PaddockStoreState {
  lastRefresh: string | undefined;
}

const initialState: PaddockStoreState = {
  lastRefresh: undefined
};

export const RefreshStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setLastRefresh(lastRefresh: string) {
      patchState(store, { lastRefresh });
    }
  }))
);
